import React, { Component } from "react";
import ReactDOM from "react-dom";
import map  from 'lodash/map';
import size  from 'lodash/size';
import round  from 'lodash/round';
import findIndex  from 'lodash/findIndex';
import find  from 'lodash/find';
import JobDetails from "./JobDetails";
import CarType from "./CarType";
import PageLoader from "../common/PageLoader";
import moment from "moment";
import {appBasePath, imageBasePath} from "../../constants/staticData";

export default class RequestCard extends Component {
  constructor(...args) {
    super(...args);
    this.toggleSwitchVal = {
      Open24_7: false,
      showFavourites: false,
      byCash: false,
      byCreditcard: false
    };
    const currentRoute = this.props.router.getCurrentLocation();
    const jobid =
      currentRoute.query && currentRoute.query.jobid
        ? currentRoute.query.jobid
        : undefined;
    const garage_id =
      currentRoute.query && currentRoute.query.garage_id
        ? currentRoute.query.garage_id
        : undefined;
    this.state = {
      windowWidth: 0,
      showFullPageLoader: false,
      mobJD:  "job-card",
      mobileFilterItem: false,
      mobileSortItem: false,
      locationSearch: {
        lat: undefined,
        lng: undefined,
        pinImage: ""
      },
      isButtonLoading: false,
      isLoading: true,
      filterdropdownVisible: false,
      dataChange: "",
      setCenter: false,
      mapsCenter: { lat: 12.9952672, lng: 77.5905857 },
      switched: false,
      filterSort: "dateNO",
      filterdropdown: false,
      driverInfo: false,
      pollCountObj: "",
      batchId: "",
      now: moment(),
      sortBydropdown: false,
      daySelected: {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thrusday: false,
        friday: false,
        saturday: false
      },
      daySelectedKey: [false, false, false, false, false, false, false],
      daySelectedValue: [],
      changedWeek: false,
      filterType: "",
      open: false,
      rangeFromDefault: moment("2016-12-19T00:00:00+05:30"),
      rangeToDefault: moment("2016-12-19T23:59:00+05:30"),
      rangefrom: undefined,
      rangeto: undefined,
      jobUpdates: jobid ? "quotes" : "details",
      currentWidth: "",
      activelatitude: "",
      activelongitue: "",
      jobCardDetails: [],
      quotation: jobid ? false : true,
      messages: jobid ? true : false,
      mapView: jobid ? false : true,
      quotationView: jobid ? true : false,
      activeSvg:
        "data:image/svg+xml,%3Csvg%20width%3D%2236px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2036%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2042%20%2836781%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3Elocation-pin%20copy%209%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C3.99742905%20C0%2C1.78970995%201.7852456%2C0%203.99017859%2C0%20L32.0098214%2C0%20C34.2135362%2C0%2036%2C1.78197514%2036%2C3.99742905%20L36%2C25.1917601%20C36%2C27.3994792%2034.4851438%2C30.1580906%2032.6302879%2C31.3444558%20L19.0975342%2C40%20L3.48057588%2C31.1594879%20C1.5583069%2C30.071322%200%2C27.407214%200%2C25.1917601%20L0%2C3.99742905%20Z%22%20id%3D%22path-1%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20maskContentUnits%3D%22userSpaceOnUse%22%20maskUnits%3D%22objectBoundingBox%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2240%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C/use%3E%0A%20%20%20%20%20%20%20%20%3C/mask%3E%0A%20%20%20%20%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-opacity%3D%220.455219656%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22location-pin-copy-9%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%224%22%20fill%3D%22%2323AE49%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Rectangle-10-Copy-3%22%20mask%3D%22url%28%23mask-2%29%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C/use%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3Ctext%20transform%3D%22translate%2818.5%2021%29%22%20fill%3D%22%23fff%22%20style%3D%22font-family%3A%20Arial%2C%20sans-serif%3Bfont-weight%3Abold%3Btext-align%3Acenter%3B%22%20font-size%3D%2212%22%20text-anchor%3D%22middle%22%3E",
      svg:
        "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2236px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2036%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2042%20(36781)%20-%20http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch%20--%3E%0A%20%20%20%20%3Ctitle%3ERectangle%2010%20Copy%203%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C3.99742905%20C0%2C1.78970995%201.7852456%2C0%203.99017859%2C0%20L32.0098214%2C0%20C34.2135362%2C0%2036%2C1.78197514%2036%2C3.99742905%20L36%2C25.1917601%20C36%2C27.3994792%2034.4851438%2C30.1580906%2032.6302879%2C31.3444558%20L19.0975342%2C40%20L3.48057588%2C31.1594879%20C1.5583069%2C30.071322%200%2C27.407214%200%2C25.1917601%20L0%2C3.99742905%20Z%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20maskContentUnits%3D%22userSpaceOnUse%22%20maskUnits%3D%22objectBoundingBox%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2240%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-opacity%3D%220.455219656%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22location-pin%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%224%22%20fill%3D%22%23EE3124%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Rectangle-10-Copy-3%22%20mask%3D%22url(%23mask-2)%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Ctext%20transform%3D%22translate(18.5%2021)%22%20fill%3D%22%23fff%22%20style%3D%22font-family%3A%20Arial%2C%20sans-serif%3Bfont-weight%3Abold%3Btext-align%3Acenter%3B%22%20font-size%3D%2212%22%20text-anchor%3D%22middle%22%3E",
      svgEnd: "</text>%0A</svg>",
      distValue: { min: 0, max: 20 },
      priceValue: { min: 0, max: 30000 },
      selectedVendorId: garage_id || 0,
      ratingValue: 0,
      inValidTime: false,
      selectedJobId: jobid || undefined,
      sortValue: "distance",
      filterActivated: undefined,
      driverLatInfo: "",
      driverLngInfo: "",
      openPopover: false,
      isCardPayment: true,
      isShopPayment: false,
      isPaymentButtonLoading: false,
      isPayAtShopEnabled: false,
    };
    this.removeFav = this.removeFav.bind(this);
    this.acceptQuotes = this.acceptQuotes.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.windowWidth = this.windowWidth.bind(this);
    this.sortBy = this.sortBy.bind(this);
    this.viewMessaging = this.viewMessaging.bind(this);
    this.filterSelect = this.filterSelect.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.driverDetails = this.driverDetails.bind(this);
    this.updateDatalat = this.updateDatalat.bind(this);
    this.makePayment = this.makePayment.bind(this);
    this.InspectionTotal = this.InspectionTotal.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  }

  componentWillMount() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition.bind(this));
    } else {
      alert("Geolocation is not supported by this browser.");
    }
    this.updateDimensions();
    window.addEventListener("mousedown", this.bodyClick.bind(this));


    window.addEventListener('resize', this.updateWindowDimensions);
    // if (this.props.jobType == 'waiting' || this.props.jobType == undefined) {
    //   this.setState({ jobUpdates: "details" })
    // }
  }
  updateWindowDimensions() {
    this.setState({ mobJD: window.innerWidth < 812 ? "": "job-card"});
  }
  componentDidMount() {
    // console.log("bookingRequestReducer = ", this.props);
    window.addEventListener("resize", this.updateDimensions);
    // if (this.props.jobType == 'waiting' || this.props.jobType == undefined) {
    //   this.setState({ jobUpdates: "details" })
    // }
    const currentRouteLocation = this.props.router.getCurrentLocation();
    if (
      currentRouteLocation.query &&
      currentRouteLocation.query.view == "message"
    ) {
      const jobid =
        currentRouteLocation.query && currentRouteLocation.query.jobid
          ? currentRouteLocation.query.jobid
          : undefined;
      this.viewMessaging(jobid);
      this.setState({ messages: true });
    } else if (
      currentRouteLocation.query &&
      currentRouteLocation.query.view == "quotes"
    ) {
      this.showLoader();
      setTimeout(() => {
        this.jobDetail("quotes");
        this.viewQuotation();
        this.setState({ quotationView: false, mobJD: 'job-card' });
        this.showLoader();
      }, 2000);
    }
    // if (this.props.jobType == 'active') {
    //   this.setState({ mapView: true, quotationView: false })
    // }
    let that = this;
    window.socket.on('Driver Location', function (data) {
      that.updateDatalat(data);
    });
  }

  updateDatalat(data) {
    this.setState({
      driverLatInfo: data.location.lat,
      driverLngInfo: data.location.lng
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.bookingRequestReducer.hideButtonLoader) {
      this.setState({ isButtonLoading: false });
    }
    if (nextProps.bookingRequestReducer.isLoaded) {
      this.setState({ isLoading: false });
      this.props.actions.clearBookingReducerComponentKey();
    }
    let batchId =
      nextProps &&
      nextProps.bookingRequestReducer &&
      nextProps.bookingRequestReducer.bookingRequests &&
      nextProps.bookingRequestReducer.bookingRequests[nextProps.requestId] &&
      nextProps.bookingRequestReducer.bookingRequests[nextProps.requestId]
        .batch_id;
    let pollCountObj =
      nextProps &&
      nextProps.bookingRequestReducer &&
      nextProps.bookingRequestReducer.batchIdList &&
      nextProps.bookingRequestReducer.batchIdList[batchId];
    if (
      nextProps &&
      nextProps.bookingRequestReducer &&
      nextProps.bookingRequestReducer.bookingRequests &&
      nextProps.requestId &&
      nextProps.bookingRequestReducer.batchIdList
    ) {
      this.setState({
        pollCountObj: pollCountObj,
        batchId: batchId
      });
    }
    let jobData =
      nextProps.bookingRequestReducer.bookingRequests &&
      nextProps.bookingRequestReducer.bookingRequests[nextProps.requestId] &&
      nextProps.bookingRequestReducer.bookingRequests[nextProps.requestId];

    let displayname =
      jobData && jobData.requeststatus && jobData.requeststatus.displayname;
    if (displayname == "Completed") {

      this.updateWindowDimensions();
      this.setState({ jobUpdates: 'quotes' })
    }

    let vendorQuotesList =
      jobData && jobData.vendorQuotesList ? jobData.vendorQuotesList : {};
    let jobCardDetails = [];
    map(vendorQuotesList.garagejobquotes, value => {
      jobCardDetails.push(value);
    });
    jobCardDetails &&
      map(jobCardDetails, (value, key) => {
        // console.log('What is the value ', value);
        if (value.garageId === this.state.selectedVendorId) {
          jobCardDetails[key] = {
            ...jobCardDetails[key],
            isActive: true
          };
          return;
        }
        /*if (key == 0) {
          jobCardDetails[key] = {
            ...jobCardDetails[key],
            isActive: true
          };
        } else {
          jobCardDetails[key] = {
            ...jobCardDetails[key],
            isActive: false
          };
        }*/
      });
    jobCardDetails &&
      this.setState({
        jobCardDetails: jobCardDetails,
        setCenter: true,
        mapsCenter:
          jobCardDetails.length && jobCardDetails[0].garage
            ? {
              lat: Number(jobCardDetails[0].garage.latitude),
              lng: Number(jobCardDetails[0].garage.longitude)
            }
            : { lat: 0, lng: 0 }
      });

    if(jobData && jobData.paymentstatus && jobData.paymentstatus.method && ! this.state.isPaymentButtonLoading){
      this.setState({ isPayAtShopEnabled:  jobData.paymentstatus.method == 'Pay at Shop'?true: false })
    }


    if (!this.state.driverLatInfo && jobData) {
      if (
        jobData &&
        jobData.garagejobquotes &&
        jobData.garagejobquotes.length > 0 &&
        jobData.garagejobquotes[0].emergencyjobdetails[0] != undefined &&
        jobData.garagejobquotes[0].emergencyjobdetails.length > 0
      ) {
        let driverlatlong = jobData.garagejobquotes[0].emergencyjobdetails[0];
        this.setState({
          driverLatInfo: driverlatlong.latitude,
          driverLngInfo: driverlatlong.longitude
        });
      }
    }

    if(nextProps && nextProps.bookingRequestReducer &&  nextProps.bookingRequestReducer.status){

     if(nextProps.bookingRequestReducer.paymentUrl && this.state.isPaymentButtonLoading ) {
       if (nextProps.bookingRequestReducer.method == 1) {
         window.location.href = nextProps.bookingRequestReducer.paymentUrl;
       } else {
         this.props.actions.getBookingRequest(nextProps.requestId, this.props.router);

         this.setState({isPaymentButtonLoading: false})
       }
     }

    }else{
      this.setState({isPaymentButtonLoading: false})
    }


  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    window.removeEventListener("mousedown", this.bodyClick.bind(this));
  }

  showLoader() {
    this.setState({
      showFullPageLoader: !this.state.showFullPageLoader,
    });
  }

  jobDetail(val) {
    this.setState({ jobUpdates: val });
  }

  showPosition(position) {
    let positionVal = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
      pinImage: `${imageBasePath}/images/map_blue_pointer.png`
    };
    this.setState({ locationSearch: positionVal });
  }

  bodyClick(e) {
    if (
      (e.target.closest(".filter-dropdown") ||
        e.target.closest(".showFilters")) &&
      !this.state.filterdropdown
    ) {
      this.setState({ filterdropdown: true, sortBydropdown: false });
    } else if (
      (e.target.closest(".showSortBy") || e.target.closest(".sortFilter")) &&
      !this.state.sortBydropdown
    ) {
      this.setState({ sortBydropdown: true, filterdropdown: false });
    } else if (e.target.closest(".mobile-tp")) {
      this.setState({ filterdropdown: false });
    } else if (e.target.closest(".rc-time-picker-panel")) {
      this.setState({ filterdropdown: true, sortBydropdown: false });
    } else if (
      e.target.closest(".Filterby") == null &&
      e.target.closest(".sortFilter") == null
    ) {
      this.setState({ filterdropdown: false, sortBydropdown: false });
    }
  }

  filterDropDownFunc(e) {
    if (!this.state.filterdropdownVisible) {
      this.setState({ filterdropdown: e });
    }
  }

  updateDimensions() {
    const windowWidth = this.windowWidth();
    this.setState({ currentWidth: windowWidth });
  }

  windowWidth() {
    let docElemProp = window.document.documentElement.clientWidth,
      body = window.document.body;
    return (
      (window.document.compatMode === "CSS1Compat" && docElemProp) ||
      (body && body.clientWidth) ||
      docElemProp
    );
  }
  btnClickFunc(requestId, jobId) {
    this.props.actions.getQuotesPricingDetails(requestId, jobId);
    this.setState({
      mapView: false,
      selectedJobId: jobId,
      quotationView: true,
      quotation: true,
      messages: false
    });
    if (this.state.currentWidth < 991) {
      this.viewQuotation();
    }
  }
  viewMessaging(jobId) {
    this.setState({
      mapView: false,
      selectedJobId: jobId,
      quotationView: true,
      quotation: false,
      messages: true,
      jobUpdates: "quotes",
      mobJD: ''
    });
  }
  mapClick(map) {
    let update,
      newDetails = [];
    this.state.jobCardDetails.map((value, key) => {
      if (
        value.garage &&
        (round(Number(value.garage.latitude), 6) ==
          round(map.latLng.lat(), 6) &&
          round(Number(value.garage.longitude), 6) ==
          round(map.latLng.lng(), 6))
      ) {
        update = {
          ...value,
          pinImage: this.state.activeSvg + key + this.state.svgEnd,
          isActive: true,
          zIndex: 999
        };
      } else {
        update = {
          ...value,
          pinImage: this.state.svg + key + this.state.svgEnd,
          isActive: false,
          zIndex: 9
        };
      }
      newDetails.push(update);
    });
    this.setState({
      jobCardDetails: newDetails
    });
    this.setState({
      scrollTo:
        Object.keys(this.currentTopEle).length > 0
          ? ReactDOM.findDOMNode(this.currentTopEle).getBoundingClientRect().top
          : 0
    });
  }
  ClickedQuoteCard(key, vendorId) {
    let update,
      newArray = [],
      centerLat = undefined,
      centerLng = undefined;
    map(this.state.jobCardDetails, (val, index) => {
      if (val.garage && val.garage.id == vendorId) {
        update = {
          ...val,
          isActive: true,
          pinImage: this.state.activeSvg + index + this.state.svgEnd,
          zIndex: 999
        };
        (centerLat = val.garage.latitude), (centerLng = val.garage.longitude);
      } else {
        update = {
          ...val,
          isActive: false,
          pinImage: this.state.svg + index + this.state.svgEnd,
          zIndex: 9
        };
      }
      newArray.push(update);
    });
    this.setState({
      jobCardDetails: newArray,
      selectedVendorId: vendorId,
      mapsCenter: { lat: centerLat, lng: centerLng },
      setCenter: true
    });
  }
  closeChat() {
    this.setState({ mapView: true, quotationView: false });
  }
  viewQuotation() {
    this.setState({
      quotation: true,
      messages: false,
      driverInfo: false,
      mobJD: ""
    });
  }
  viewMessages() {
    this.setState({ quotation: false, messages: true, mobJD: "" });
  }
  driverDetails() {
    this.setState({ quotation: false, driverInfo: true });
  }

  day(selDay, day) {
    let days = { ...this.state.daySelected };
    let daysValue = [...this.state.daySelectedKey];
    days[selDay] = !this.state.daySelected[selDay];
    daysValue[day] = !this.state.daySelectedKey[day];
    this.setState({
      daySelected: days,
      daySelectedKey: daysValue
    });
  }

  sortBy(jobId, value) {
    this.props.actions.getVendorQuotesList(
      jobId,
      value,
      this.state.distValue,
      this.state.priceValue,
      this.state.daySelectedValue,
      this.state.rangefrom,
      this.state.rangeto,
      this.state.ratingValue,
      this.toggleSwitchVal,
      this.props.commonReducer.userLocation,
    );
  }

  filterOption(val, sortValue) {
    this.setState({
      filterSort: val,
      sortBydropdown: false,
      sortValue: sortValue
    });
  }

  clearFilter(jobId) {
    this.toggleSwitchVal = {
      Open24_7: false,
      showFavourites: false,
      byCash: false,
      byCreditcard: false
    };
    this.setState({
      ratingValue: 0,
      inValidTime: false,
      TimePickerFrom: undefined,
      daySelectedValue: [],
      daySelectedKey: [false, false, false, false, false, false, false],
      TimePickerTo: undefined,
      rangefrom: undefined,
      rangeto: undefined,
      filterActivated: false,
      rangeFromDefault: moment("2016-12-19T00:00:00+05:30"),
      rangeToDefault: moment("2016-12-19T23:59:00+05:30"),
      distValue: { min: 0, max: 20 },
      priceValue: { min: 0, max: 30000 },
      daySelected: {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thrusday: false,
        friday: false,
        saturday: false
      }
    });
    this.props.actions.getVendorQuotesList(jobId, this.state.sortValue);
  }

  switch(val) {
    this.toggleSwitchVal[val] = !this.toggleSwitchVal[val];
    if (val == "byCash") {
      this.toggleSwitchVal.byCreditcard = false;
    } else if (val == "byCreditcard") {
      this.toggleSwitchVal.byCash = false;
    }
    this.setState({ switched: !this.state.switched });
  }

  rangefrom(value, menu) {
    let res = {
      rangefrom: value.format("hh:mm A"),
      rangeFromDefault: value
    };
    if (menu) {
      res["filterdropdown"] = false;
    }
    this.setState(res);
  }

  rangeTo(value, menu) {
    let res = {
      rangeto: value.format("hh:mm A"),
      rangeToDefault: value
    };
    if (menu) {
      res["filterdropdown"] = false;
    }
    this.setState(res);
  }

  filterSelect(jobId) {
    let daysSelected = [];
    let filterActivated = false;
    map(this.state.daySelectedKey, (value, key) => {
      if (value) {
        daysSelected.push(key + 1);
      }
    });
    if (
      (this.toggleSwitchVal && this.toggleSwitchVal["byCash"]) ||
      this.toggleSwitchVal["byCreditcard"] ||
      this.toggleSwitchVal["Open24_7"] ||
      this.toggleSwitchVal["showFavourites"] ||
      this.state.ratingValue ||
      this.state.distValue ||
      this.state.priceValue ||
      daysSelected.length ||
      this.state.rangefrom ||
      this.state.rangeTo
    ) {
      filterActivated = true;
    }
    this.setState({
      filterdropdown: false,
      daySelectedValue: daysSelected,
      filterActivated: filterActivated,
      mobileFilterItem: false
    });
    this.props.actions.getVendorQuotesList(
      jobId,
      this.state.sortValue,
      this.state.distValue,
      this.state.priceValue,
      daysSelected,
      this.state.rangefrom,
      this.state.rangeto,
      this.state.ratingValue,
      this.toggleSwitchVal,
      this.props.commonReducer.userLocation,
    );
  }

  statusIndicatorFunc(status, previousDisplayname) {
    if (status == "Cancelled" || status == "Expired") {
      status = previousDisplayname;
    }
    if (
      status == "Completed" ||
      status == "Accepted" ||
      status == "In-progress" || status == "Driver Accepted"
    ) {
      return "Accepted Quotes";
    } else {
      return "Quotes";
    }
  }

  removeFav(event, status, vendorId, userRequestId) {
    event.stopPropagation();
    event.preventDefault();
    this.props.actions.changeFavouriteSelection(
      vendorId,
      status,
      "activeVendors",
      userRequestId
    );
  }

  ratingOnChange(rating) {
    this.setState({ ratingValue: rating });
  }

  setCenter() {
    this.setState({ setCenter: true });
  }

  acceptQuotes(id, jobID, requestId, router) {
    this.setState({ isButtonLoading: true });
    this.props.actions.acceptQuotes(id, jobID, requestId, router);
  }
  bckButton() {
    this.setState({ mobileSortItem: false, mobileFilterItem: false });
  }
  requestSort(val, sortVal, JobId) {
    this.filterOption(val, sortVal);
    this.sortBy(JobId, sortVal);
    this.setState({ mobileSortItem: false });
  }
  distValue(type, value) {
    type == "distance"
      ? this.setState({ distValue: value })
      : this.setState({ priceValue: value });
  }
  changeJobType() {
    this.setState({ mobJD: "" });
  }

  makePayment( jobId, requestId) {

    this.setState({ isPaymentButtonLoading: true })

    let method = 2;

    if(this.state.isCardPayment)
      method = 1;

    this.props.actions.makePayment(requestId, jobId, method);
  }

  updateRadioButton(type) {


    this.setState({ isCardPayment: type == "cardPayment"? true: false, isShopPayment : type == "shopPayment"? true: false })

  }

  InspectionTotal(qouteInfo){
    let totalInspection = 0;
    qouteInfo.map((quote)=>{
      totalInspection+=quote.inspectionamount;
    })
    return Number(totalInspection);
  }

  render() {
    const {
      requestId,
      jobType,
      router,
      bookingRequestReducer,
      actions,
      userPaymentStatus
    } = this.props;
    let jobNotesObj = {};

    console.log("userPaymentStatus",userPaymentStatus)
    { console.log("bookingRequestReducer = ", bookingRequestReducer); }
    if (bookingRequestReducer && bookingRequestReducer.garagejobquotesdetail && bookingRequestReducer.garagejobquotesdetail.length) {
      jobNotesObj = bookingRequestReducer.garagejobquotesdetail[0].garage.garagejobnotes[0];
    }
    let jobLeftGridValue = "";
    let jobRightGridValue = "";
    if (this.state.currentWidth <= 1155 && this.state.currentWidth >= 992) {
      jobLeftGridValue = "col-md-7";
      jobRightGridValue = "col-md-5";
    } else if (
      this.state.currentWidth <= 1345 &&
      this.state.currentWidth >= 1155
    ) {
      jobLeftGridValue = "col-md-6";
      jobRightGridValue = "col-md-6";
    } else {
      jobLeftGridValue = "col-md-5";
      jobRightGridValue = "col-md-7";
    }

    let jobData =
      bookingRequestReducer.bookingRequests &&
      bookingRequestReducer.bookingRequests[requestId] &&
      bookingRequestReducer.bookingRequests[requestId];
    let jobId = jobData && jobData.id;
    let vendorQuotesList =
      jobData && jobData.vendorQuotesList ? jobData.vendorQuotesList : {};
    let displayname =
      jobData && jobData.requeststatus && jobData.requeststatus.displayname;
    if (displayname == "accepted") {
      this.changeJobType.bind(this);
    }

    let previousDisplayname =
      jobData &&
      jobData.previousrequeststatus &&
      jobData.previousrequeststatus.displayname;
    let vendorIndex =
      this.state.selectedVendorId &&
      findIndex(vendorQuotesList.garagejobquotes, {
        garageId: Number(this.state.selectedVendorId)
      });

    let garageQuotesPricingDetails = {};

    garageQuotesPricingDetails =
      vendorIndex != -1 &&
      vendorQuotesList.garagejobquotes &&
      size(vendorQuotesList.garagejobquotes) &&
      vendorQuotesList.garagejobquotes[vendorIndex];
    garageQuotesPricingDetails = (jobData && displayname == 'Accepted') ||
      displayname == 'In-progress' ||
      displayname == 'Completed' || displayname == 'Driver Accepted' ||
      (displayname == 'Cancelled' && previousDisplayname == 'Accepted') ||
      (displayname == 'Expired' && previousDisplayname == 'Accepted')
      ? jobData.garagejobquotes[0]
      : garageQuotesPricingDetails;
    garageQuotesPricingDetails = (!garageQuotesPricingDetails &&
      (displayname == 'Cancelled' && previousDisplayname == 'Active')) ||
      (displayname == 'Expired' && previousDisplayname == 'Active')
      ? vendorQuotesList.garagejobquotes &&
      size(vendorQuotesList.garagejobquotes) &&
      vendorQuotesList.garagejobquotes[0]
      : garageQuotesPricingDetails;
    let promoOffer = jobData && jobData.offer ? jobData.offer : null;
    let totalAmount = garageQuotesPricingDetails && garageQuotesPricingDetails.totalamount;
    let vatAmount = garageQuotesPricingDetails && garageQuotesPricingDetails.taxesAmount;
    let vatPercent = garageQuotesPricingDetails && garageQuotesPricingDetails.taxes && garageQuotesPricingDetails.taxes.length && garageQuotesPricingDetails.taxes[0].value;
    let offerDiscount = 0;
    if (promoOffer) {
      if (promoOffer.discountPercentage || promoOffer.discountAmount) {
        if (promoOffer.discountPercentage) {
          let discountPercentage = promoOffer && promoOffer.discountPercentage;
          offerDiscount = (totalAmount * (discountPercentage / 100));
          offerDiscount = offerDiscount > 0 ? offerDiscount.toFixed(2) : offerDiscount;
          totalAmount -= offerDiscount;
        } else {
          offerDiscount = promoOffer.discountAmount > 0 ? (promoOffer.discountAmount).toFixed(2) : promoOffer.discountAmount;
          totalAmount -= offerDiscount;
        }
      }
    }

    // if(garageQuotesPricingDetails && (requestId.includes("REP")|| requestId.includes("SRV"))){
    //   totalAmount+= this.InspectionTotal(garageQuotesPricingDetails.garagejobquotesdetail);
    // }

    let startDate = garageQuotesPricingDetails && new Date(garageQuotesPricingDetails.jobStartDatetime);
    let endDate = garageQuotesPricingDetails && garageQuotesPricingDetails.jobEndDatetime && new Date(garageQuotesPricingDetails.jobEndDatetime);
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    startDate = startDate &&
      startDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) +
      ' on ' +
      months[startDate.getMonth()] +
      ' ' +
      startDate.getDate() +
      ' ' +
      startDate.getFullYear();
    endDate = endDate &&
      endDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) +
      ' on ' +
      months[endDate.getMonth()] +
      ' ' +
      endDate.getDate() +
      ' ' +
      endDate.getFullYear();
    let createdAt = garageQuotesPricingDetails && new Date(garageQuotesPricingDetails.createdAt);
    createdAt = createdAt && months[createdAt.getMonth()] + ' ' + createdAt.getDate() + ' ' + createdAt.getFullYear();
    let locationIndex = 0;
    console.log("garageQuotesPricingDetails = ", garageQuotesPricingDetails);
    if (garageQuotesPricingDetails && garageQuotesPricingDetails.garage && garageQuotesPricingDetails.garage.garagejobnotes && garageQuotesPricingDetails.garage.garagejobnotes.length) {
      jobNotesObj = garageQuotesPricingDetails.garage.garagejobnotes[0];
    }
    console.log("userbookingrequest_services = ", jobData);

    let quotesArr = [];
    let quotesNameArr = [];
    let userQuotesArr = [];
    let userQuotesNameArr = [];
    if (garageQuotesPricingDetails && jobData && garageQuotesPricingDetails.garagejobquotesdetail && jobData.userbookingrequest_services) {

      quotesArr = garageQuotesPricingDetails.garagejobquotesdetail;
      userQuotesArr = jobData.userbookingrequest_services;

      quotesArr.forEach((quoteItem) => {
        quotesNameArr.push(quoteItem.name);
      });
      userQuotesArr.forEach((userQuotesitem) => {
        userQuotesNameArr.push(userQuotesitem.name);
      });
      let wrapperArr = [];
      userQuotesArr.forEach((userQuotesitem) => {
        let obj = {};
        let index = userQuotesNameArr.indexOf(userQuotesitem.name);
        console.log("name = ", userQuotesNameArr[index]);
        if (!quotesNameArr.includes(userQuotesNameArr[index])) {
          obj = {
            name: userQuotesitem.name,
            parentId: userQuotesitem.parentId,
            serviceId: userQuotesitem.serviceId,
            parent: userQuotesitem.parent,
            amount: 0,
            currency: "",
            description: null
          };
          wrapperArr.push(obj);
        }
      });
      console.log("wrapperArr = ", wrapperArr);
      quotesArr = quotesArr.concat(wrapperArr);
    }

    console.log("quotesArr = ", quotesArr);
    const displayQuotesArr = quotesArr;
    const jobCardLocation = map(this.state.jobCardDetails, (val, key) => {
      let garage = val && val.garage;
      locationIndex += 1;
      let coverImg = "";
      if (garage && garage.images && garage.images.length) {
        coverImg = find(garage.images, function (image) {
          return image.isCover == true;
        });
      }
      return {
        lat: garage && Number(garage.latitude),
        lng: garage && Number(garage.longitude),
        pinImage: val.isActive
          ? this.state.activeSvg + locationIndex + this.state.svgEnd
          : this.state.svg + locationIndex + this.state.svgEnd,
        name: garage && garage.companyprofilename,
        rating: garage && garage.rating,
        distance: garage && garage.distance,
        review: garage && garage.reviews,
        zIndex: val.zIndex ? val.zIndex : 9,
        image: coverImg && coverImg.medium
      };
    });
    let serviceIndex = 0;
    {
      /*let DriverinfoDetails = (typeof jobData.garagejobquotes[0].emergencyjobdetails !== 'undefined') ? (jobData.garagejobquotes[0].emergencyjobdetails.length > 0 ? jobData.garagejobquotes[0].emergencyjobdetails[0].jobqueue : "0" ) :"0";*/
    }
    let DriverinfoDetails =
      jobData &&
        jobData.garagejobquotes &&
        jobData.garagejobquotes.length > 0 &&
        jobData.garagejobquotes[0].emergencyjobdetails[0] != undefined &&
        jobData.garagejobquotes[0].emergencyjobdetails.length > 0
        ? jobData.garagejobquotes[0].emergencyjobdetails[0].jobqueue
        : "0";
    //alert(DriverinfoDetails);



    return (
      <div>
        {
          this.state.showFullPageLoader ? <PageLoader /> : <div className="request-card plus-request-card">
            <div>
              {jobData && (
                <CarType
                  source={"requestview"}
                  authReducer={this.props.authReducer}
                  bookingRequestReducer={this.props.bookingRequestReducer}
                  actions={actions}
                  cardDetails={jobData}
                  vendorQuotesCount={jobData && jobData.totalJobQuotes}
                  jobLeftGridValue={jobLeftGridValue}
                  jobRightGridValue={jobRightGridValue}
                  userPaymentStatus={userPaymentStatus}
                  router={router}
                  quotesClick={this.jobDetail.bind(this, "quotes")}
                />
              )}
            </div>
            <div className="requestSection plus-request-section">
              <div className="row">
                {!this.state.isLoading
                  ? <div className={jobType == 'active' ? 'request-summary vendor-list-view' : 'request-summary'}>
                    <div className="row request-summary-header">

                          <h1>Job Details</h1>

                    </div>
                    <div className="row request-summary-body">
                      {this.state.jobUpdates == 'details' &&
                        jobData &&
                        <div className="tab-jobDetails">
                          <JobDetails
                            displayname={displayname}
                            pollCountObj={this.state.pollCountObj}
                            batchId={this.state.batchId}
                            serviceTypes={jobData.services && jobData.services.name}
                            requestData={jobData}
                            router={router}
                            actions={actions}
                          />
                        </div>}

                    </div>
                  </div>
                  : <PageLoader />}
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}
